import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Issues from './pages/Issues';
import Optimizations from './pages/Optimizations';
import Optimizer from './pages/Optimizer';
import Designer from './pages/Designer';
import Documentation from './pages/Documentation';
import SEO from './pages/SEO';
import Sponsoring from './pages/Sponsoring';
import Zusammenbesteller from './pages/Zusammenbesteller';
import ThesisChecker from './pages/ThesisChecker';
import PremiumCodesAdmin from './pages/PremiumCodesAdmin';
import BindungsBerater from './pages/BindungsBerater';
import ArbeitCheckerDemo from './pages/ArbeitCheckerDemo';
import Navigation from './components/Navigation';
import AuthGate from './components/AuthGate';
import { Toaster } from './components/ui/sonner';
import './App.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

function App() {
  return (
    <AuthGate>
      <div className="App min-h-screen bg-slate-50">
        <BrowserRouter>
          <Navigation />
          <main className="pt-16">
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/optimizer" element={<Optimizer />} />
              <Route path="/designer" element={<Designer />} />
              <Route path="/issues" element={<Issues />} />
              <Route path="/optimizations" element={<Optimizations />} />
              <Route path="/seo" element={<SEO />} />
              <Route path="/docs" element={<Documentation />} />
              <Route path="/sponsoring" element={<Sponsoring />} />
              <Route path="/zusammenbesteller" element={<Zusammenbesteller />} />
              <Route path="/zusammenbesteller/:code" element={<Zusammenbesteller />} />
              <Route path="/thesis-checker" element={<ThesisChecker />} />
              <Route path="/thesis-checker/demo" element={<ArbeitCheckerDemo />} />
              <Route path="/premium-codes" element={<PremiumCodesAdmin />} />
              <Route path="/bindungs-berater" element={<BindungsBerater />} />
            </Routes>
          </main>
          <Toaster position="top-right" />
        </BrowserRouter>
      </div>
    </AuthGate>
  );
}

export default App;